import React from 'react';
import Home from '../Home';
import LogoHero from '../../img/my_logo_tm.png'


// Main App Component
export default function LogoBranding() {
  return (
    <Home>
    <div className="min-h-screen flex flex-col text-[#333] font-sans">
      {/* Header Section */}
      <header className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col-reverse md:flex-row items-center justify-between gap-8">
            <div className="max-w-xl text-center md:text-left">
              <p className="text-gray-600 text-sm sm:text-base font-semibold mb-2">Best Logo Design Services</p>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight mb-4">
                <span className="text-black">CRAFTING VISUAL IDENTITY</span><br />
                THROUGH THOUGHTFUL LOGO DESIGNS
              </h1>
              <p className="text-gray-400 text-sm sm:text-base leading-relaxed mb-6">
                For over a decade, SRK Softwares has been a leading graphic design company in India, delivering exceptional service at reasonable prices.
              </p>
              <button className="bg-[#f7a11f] text-black font-bold py-3 px-6 rounded-md uppercase hover:bg-[#e0901a] transition-colors duration-300">
                Contact Us
              </button>
            </div>
            <div className="w-full max-w-sm md:max-w-md lg:max-w-lg aspect-square flex items-center justify-center p-4">
              <img src={LogoHero} alt="Logo design illustration" className="w-full h-full object-contain" />
            </div>
          </div>
        </div>
      </header>

      {/* Define Your Brand Section */}
      <section className="bg-gray-100 py-16 text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white py-4 px-6 rounded-lg shadow-md mb-8">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#333]">
              Define Your Brand with SRK Softwares Premier Logo Design Company in India
            </h2>
          </div>
          <p className="max-w-4xl mx-auto leading-relaxed text-gray-700">
            At SRK Softwares, we're not just a logo design company; we're among the best. Our goal is simple: to create logos that stand out and are easy to remember. We believe a logo is more than just a picture; it's the core of your brand's identity and its first impression. A logo is for your business what a face is for a person, so let's make it the best.
            <br /><br />
            Our team of talented designers works hard to make every logo unique, simple, and effective. We want your business to have a lasting impact with the best logo that represents you.
            <br /><br />
            When you choose SRK Softwares, you're choosing quality. Our expert designers are here to make your brand a logo that you love, all at a reasonable price. Get in touch with us today to start the conversation and give your brand a new life with our custom logo design services.
          </p>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="bg-white py-16 text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gray-200 py-4 px-6 rounded-lg shadow-md mb-8">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#333]">Why should you choose SRK Softwares for your Logo Designs?</h2>
          </div>
          <p className="text-gray-500 mb-8">We have delivered top-notch logo designs and maintained trust with our customers. Let’s begin to impress them.</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <WhyChooseCard src={LogoHero} alt='Logo Image' title="LOGO" text="SRK Softwares provides high-end services for unique and appealing logo designs that cater to every business need. We have delivered top-notch logo designs and maintained trust with our customers. We’re experts in creating logo designs that tell a story." />
            <WhyChooseCard src={LogoHero} alt='Logo Image' title="CREATIVE EXCELLENCE" text="We offer high-quality services for custom logo designs. We bring your vision to life, creating unique and appealing logo designs. Our ability to grasp your ideas and transform them into a unique logo that expresses your identity gives us an edge over our competitors." />
            <WhyChooseCard src={LogoHero} alt='Logo Image' title="TAILORED BRAND IDENTITY" text="SRK Softwares takes the time to deeply understand your brand, its values, and its target audience. We believe in creating logo designs that tell a story. Our designs don’t just look good; they are strategically made to connect with your audience, ensuring your brand is both memorable and meaningful." />
          </div>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
            <WhyChooseCard src={LogoHero} alt='Logo Image' title="LOGO" text="SRK Softwares is known for its creative logo designs that capture the essence of your brand. We are passionate about creating logos that not only look good but also carry a deep meaning." />
            <WhyChooseCard src={LogoHero} alt='Logo Image' title="COLLABORATIVE APPROACH" text="We believe in teamwork. We work closely with you from the start to the end, prioritizing your feedback. Our collaborative process ensures that the final design is not just something we like but something you love. Your satisfaction is our success." />
          </div>
        </div>
      </section>
      
      {/* What Makes a Logo Great Section */}
      <section className="bg-gray-100 py-16 text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white py-4 px-6 rounded-lg shadow-md mb-8">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#333]">What makes a logo great?</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <LogoGreatCard title="Simple and Easy to Remember" text="A great logo is simple but elegant. It’s a logo that people can easily recognize and remember." />
            <LogoGreatCard title="Shows What Your Brand Is" text="The best logos tell a story. They show what your business is about just by looking at them." />
            <LogoGreatCard title="Works Everywhere and Stays Cool" text="A good logo works on everything—from a tiny app icon to a big billboard. It always looks good." />
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm">Stay connected with us on Facebook and Twitter for the latest updates, insights, and industry news.</p>
          <div className="flex justify-center items-center mt-4 space-x-4">
            <button className="bg-white text-gray-800 font-bold py-2 px-4 rounded-md uppercase text-xs">Facebook</button>
            <button className="bg-white text-gray-800 font-bold py-2 px-4 rounded-md uppercase text-xs">Twitter</button>
            <button className="bg-white text-gray-800 font-bold py-2 px-4 rounded-md uppercase text-xs">Instagram</button>
          </div>
        
        </div>
      </footer>
    </div>
    </Home>
  );
}

// Reusable "Why Choose Us" Card Component
const WhyChooseCard = ({ title, text, src ,alt }) => (
  <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center text-center transition-transform duration-200 hover:translate-y-[-5px] hover:shadow-lg">
    <div className="w-24 h-24 bg-gray-200 rounded-lg mb-4 flex items-center justify-center font-bold text-xl uppercase">
      <img src={src} alt={alt} />
    </div>
    <h3 className="text-xl font-bold mb-2">{title}</h3>
    <p className="text-sm leading-relaxed text-gray-600">{text}</p>
  </div>
);

// Reusable "What Makes a Logo Great" Card Component
const LogoGreatCard = ({ title, text }) => (
  <div className="bg-white rounded-lg shadow-md p-6 flex flex-col items-center text-center transition-transform duration-200 hover:translate-y-[-5px] hover:shadow-lg">
    <div className="w-full max-w-[200px] h-40 bg-gray-300 rounded-lg mb-4">
      <img src={LogoHero} alt="card visual" className="w-full h-full object-cover rounded-lg" />
    </div>
    <h3 className="text-xl font-bold mb-2">{title}</h3>
    <p className="text-sm leading-relaxed text-gray-600">{text}</p>
  </div>
);


